console.log($('body.template-product').length);
let check_template_product = $('body.template-product').length;
if(check_template_product > 0){
  function changePrice(){
    
    var currency = $('body').data('currency');

     var quantity = $('.product__info-container input[name="quantity"]:checked').val();
     var price = $('.product__info-container input[name="quantity"]:checked').attr("data-price");
     var priceSub = $('.product__info-container input[name="quantity"]:checked').attr("data-pricesub");
     var pricePerDayOneTime = $('.product__info-container input[name="quantity"]:checked').attr("data-priceperdayonetime");
     var pricePerDaySubscription = $('.product__info-container input[name="quantity"]:checked').attr("data-priceperdaysubscription");
     var priceSubscription = $('.product__info-container input[name="quantity"]:checked').attr("data-priceSub");
     var regularPrice = $('.product__info-container input[name="quantity"]:checked').attr("data-regularprice");

     var typeOption = $('.product__info-container .rc-radio--active').find('input[type="radio"]').val();

    //console.log(price);
    //console.log(priceSub);
    $('.rc-widget .onetime-radio .rc-radio__label').html('<span class="rc-radio__onetime">One-time purchase</span><span class="rc-radio__price">$'+price+'</span>');
    $('.rc-widget .subscription-radio .rc-radio__price').text('$'+priceSub);

    $('.price-per-day.subscription').text(pricePerDaySubscription);
    $('.price-per-day.onetime').text(pricePerDayOneTime);

    $('.product__info-container .price__regular .price-item--regular-container.extra .price-item.price-item--extra').text('  Regular Price '+regularPrice);
    $('.product__info-container .price__regular .price-item--regular-container.extra').show();
    $('.product__info-container .badge.price__badge-sale').addClass('regular');
    
    if( typeOption == 'subscription'){
       if (quantity == '1'){
         $('.product__info-container .badge.price__badge-sale').text('-30% off');
       }
       else if (quantity == '2') {
         $('.product__info-container .badge.price__badge-sale').text('-35% off');
       }
       else if (quantity == '3') {
         $('.product__info-container .badge.price__badge-sale').text('-40% off');
       }
      $('.product__info-container .price-item.price-item--regular').text(priceSubscription);
      $('.price-per-day.subscription').show();
      $('.price-per-day.onetime').hide();
    }else{
      if (quantity == '1'){
         $('.product__info-container .price__regular .price-item--regular-container.extra').hide();
         $('.product__info-container .badge.price__badge-sale').removeClass('regular');
         $('.product__info-container .badge.price__badge-sale').text('');
       }
       else if (quantity == '2') {
         $('.product__info-container .badge.price__badge-sale').text('-5% off');
       }
       else if (quantity == '3') {
         $('.product__info-container .badge.price__badge-sale').text('-10% off');
       }
      $('.product__info-container .price-item.price-item--regular').text(price);
      $('.price-per-day.subscription').hide();
      $('.price-per-day.onetime').show();
    }

    
    $('.price.price--show-badge').removeClass('visibility-hidden');
    $('.price--show-badge').css('visibility','visible');
    
  }
  
  $( window ).on( "load", function() {
      console.log( "window loaded" );
    

      var existRC = setInterval(function() {

        if ($('.product__info-container .rc-widget').length) {
          var regularPrice = $('.product__info-container input[name="quantity"]:checked').attr("data-regularprice");
          
            console.log("Exists RC!");
            clearInterval(existRC);
              //$('.product__info-container .onetime-radio .rc-radio__label').text('One-time purchase');
              //$('.product__info-container .subscription-radio .rc-radio__subscription').text('Autoship & Save (30% off)');
              //$('.product__info-container .subscription-radio .rc-radio__label').append('<span class="rc-radio__label_extra_info">Save an additional 25% on all subscription orders <br>Free Shipping</span>');

              setTimeout(function() { 
                changePrice();
              }, 200);
          
            $('.product__info-container .onetime-radio').on('click', function(){
              //$('.product__info-container .wrap-spinner').removeClass('hidden');
              $('.product__info-container .price.price--show-badge').addClass('visibility-hidden');
              setTimeout(function() { 
                changePrice();
              }, 200);
            });

            $('.product__info-container .subscription-radio').on('click', function(){
              //$('.product__info-container .wrap-spinner').removeClass('hidden');
              $('.product__info-container .price.price--show-badge').addClass('visibility-hidden');
              setTimeout(function() { 
                changePrice();
              }, 200);
            });

            $('.product__info-container input[name="quantity"]').on('change', function(){
              var existPriceContainer = setInterval(function() {
               
                if ($('.price.price--show-badge').length) {
                  //console.log("Exists - price container!");
                  clearInterval(existPriceContainer);
                  setTimeout(function() { 
                    changePrice();
                  }, 500);
                }
              }, 200); // check every 100ms
            });
   
        }
        
      }, 150); // check every 100ms

  });
}


$(document).ready(function(){
  // Select all links with hashes
  $('#product_accordion .accordion-content a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });
});





